export default __webpack_public_path__ + "static/media/Newday_COMPLAINT.56ea43df.pdf";